import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 gap-x-4 mx-8 mb-8" }
const _hoisted_2 = { class: "col-span-2 w-36 cursor-pointer" }
const _hoisted_3 = { class: "aspect-w-16 aspect-h-16" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-span-3" }
const _hoisted_6 = { class: "flex flex-col ml-6 h-full" }
const _hoisted_7 = { class: "overflow-hidden whitespace-nowrap overflow-ellipsis" }
const _hoisted_8 = { class: "text-sm text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Quantity", -1)
const _hoisted_11 = { class: "flex items-center space-x-4 text-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "cursor-pointer fas fa-plus" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text-base text-green-400" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "cursor-pointer fas fa-minus" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex flex-col col-span-1" }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

import { getProductImage } from "@/helpers/get-product-image";
import { IProduct } from "@/interfaces/IProduct";
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";
interface Props {
  product: IProduct;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
}


const store = useStore();

const shoppingCartList = computed(() => store.state.shoppingCartList);
const quantity = computed(
  () =>
    shoppingCartList.value.find((p: IProduct) => p.id === props.product.id)
      .quantity
);
const removeFromCart = () => {
  store.commit("REMOVE_FROM_CART", props.product.id);
};
const productImageUrl = computed(() =>
  getProductImage(props.product.image.url)
);
const addQuantity = () => {
  store.dispatch("updateQuantity", { productId: props.product.id, type: "+" });
};
const minusQuantity = () => {
  store.dispatch("updateQuantity", { productId: props.product.id, type: "-" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _unref(productImageUrl) }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.product.name), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.product.category.name), 1),
        _hoisted_9,
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", { onClick: addQuantity }, _hoisted_13),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(quantity)), 1),
            _createElementVNode("div", { onClick: minusQuantity }, _hoisted_16)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, "$ " + _toDisplayString(__props.product.price), 1),
      _hoisted_19,
      _createElementVNode("div", { class: "flex justify-end items-end" }, [
        _createElementVNode("div", {
          class: "text-xl text-red-600 cursor-pointer",
          onClick: removeFromCart
        }, _hoisted_21)
      ])
    ])
  ]))
}
}

})